export default __webpack_public_path__ + "static/media/background.a45b075e.jpg";